<div nz-row *ngIf="!editMode">
  <div nz-col nzSpan="14" class="sampling-group-name">
     <h3 nz-title>{{ labelName }}</h3>
  </div>
  <div nz-col nzSpan="10" class="sampling-group-actions">
    <div class="sampling-group-price">
      <h3 nz-title>{{ group.groupPrice?.amount | currency:'NZD':'symbol-narrow' }}</h3>
    </div>
    <app-cart-manage-sampling-menu
      [isProductGroup]="groupType"
      (onEdit)="onEdit($event)" (onDelete)="deleteCartGroup()">
    </app-cart-manage-sampling-menu>
  </div>
</div>

<div class="edit-sample-name" *ngIf="editMode;" [ngClass]="{ error : error && error != '' }">
  <nz-form-item>
    <nz-input-group [nzAddOnAfter]="editActions">
       <nz-form-control [nzValidateStatus]="error && error != ''? 'error':'default'" [nzErrorTip]="error">
         <input nz-input #nameInput  type="text" (keyup.enter)="updateGroupName()" [(ngModel)]="labelName" maxlength="64">
       </nz-form-control>
    </nz-input-group>
  </nz-form-item>
  <ng-template #editActions>
    <nz-button-group nzSize="small">
      <button nz-button nzSize="small" nzType="default" (click)="updateGroupName()"><i nz-icon nzType="icons/fontawesome/solid:check"></i></button>
      <button nz-button nzSize="small" nzType="default" (click)="cancelEditing()"><i nz-icon nzType="icons/fontawesome/solid:times"></i></button>
    </nz-button-group>
  </ng-template>
</div>
